<template>
  <div
    class="packagesTable-container"
  >
    <table
      class="view-table-main"
      border="0"
      cellspacing="0"
    >
      <thead class="view-table-thead">
        <tr>
          <th>
            <bk-view class="view-cellItem">
							<bk-lang code="userInfo_memberRights_rightsDetail_packages_name"></bk-lang>
						</bk-view>
          </th>
					<th>
            <bk-view class="view-cellItem">
							<bk-lang code="userInfo_memberRights_rightsDetail_packages_max"></bk-lang>
						</bk-view>
          </th>
					<th>
            <bk-view class="view-cellItem">
							<bk-lang code="userInfo_memberRights_rightsDetail_packages_used"></bk-lang>
						</bk-view>
          </th>
					<th>
            <bk-view class="view-cellItem">
							<bk-lang code="userInfo_memberRights_rightsDetail_packages_included"></bk-lang>
						</bk-view>
          </th>
					<th>
            <bk-view class="view-cellItem">
							<bk-lang code="userInfo_memberRights_rightsDetail_packages_remain"></bk-lang>
						</bk-view>
          </th>
        </tr>	
      </thead>

      <tbody class="view-table-body">
        <tr
          v-for="(item, index) of dataList" 
          :key="index" 
          class="view-tableBody-row"
        >
					<td>
						<bk-view class="view-cellItem">
							<bk-view class="view-packageName-main">
								<bk-view v-if="item.comboFlag" class="view-comboFlag-mian">
									<bk-view class="view-comboFlag-item view-goodsName" v-for="item in item.groupList" :key="item.id">{{item.goodsName}}</bk-view>
								</bk-view>
								<bk-view v-else class="view-goodsName">{{item.goodsName}}</bk-view>
							</bk-view>
						</bk-view>
					</td>
					<td>
						<bk-view class="view-cellItem">
							<bk-view class="view-packageName-main">
								<bk-view v-if="item.comboFlag" class="view-comboFlag-mian">
									<bk-view class="view-comboFlag-item" v-for="item in item.groupList" :key="item.id">{{item.maxAvailable}}</bk-view>
								</bk-view>
								<bk-view v-else>{{item.times}}</bk-view>
							</bk-view>
						</bk-view>
					</td>
					<td>
						<bk-view class="view-cellItem" :style="{height: (item.groupList?.length || 1) * 24 +'px'}">
							<bk-view class="view-packageName-main">
								<bk-view v-if="item.comboFlag" class="view-comboFlag-mian">
									<bk-view class="view-comboFlag-item" v-for="item in item.groupList" :key="item.id">{{item.usedTimes}}</bk-view>
								</bk-view>
								<bk-view v-else>{{item.usedTimes}}</bk-view>
								<bk-view class="view-line-main" v-if="item.comboFlag && item.groupList.length > 1"></bk-view>	
							</bk-view>
						</bk-view>
					</td>
					<td>
						<bk-view class="view-cellItem">{{item.times}}</bk-view>
					</td>
					<td>
						<bk-view class="view-cellItem">{{item.remainTimes}}</bk-view>
					</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
	export default {
		name:'packagesTable',
		props:{
			dataList:Array,
		}
	};
</script>

<style lang="less">
@import './packagesTable.less';
</style>